import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { APIConstants } from '../../../../_config/restapis';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { $DBManagerService } from '../../../../_helpers/DB/DBManager.service';
import { Constants } from '../../../../_utils/Constants';
import { $BroadcastManagerService } from '../../../../_helpers/BroadcastManager.service';

@Injectable()
export class APIComplaintsService {

    constructor(
        private http: HttpClient,
        private db: $DBManagerService,
        private evt: $BroadcastManagerService
    ) { }

    public getTrackComplaints(MobileNo): Observable<any> {
        return this.http.get(APIConstants.GETSUBSCRIBERCOMPLAINTSBYMOBILENOCOMPLAINTNO+MobileNo);
            //.pipe(map(r => this.parseRjioComplaints(r)));
    }
     public getComplaintsForComplaintNo(complaintNumber,oap): Observable<any> {
        //const url = this.getUrl();
        return this.http.get(APIConstants.GETCOMPLAINTBYCOMPLAINTNUMBER+complaintNumber+'/'+oap);
    
    } 
    public checkDelEmailMobile(data): Observable<any> {
        return this.http.post(APIConstants.SENDOTPMOBILE,data)
     }
   ////Complaint Registration – Subscriber 001
       public verifyDelNumber(data): Observable<any> {
        return this.http.post(APIConstants.VERIFYDELNO,data)
     }
    public sendOTP(data): Observable<any> {
        return this.http.post(APIConstants.VERIFYOTPMOBILE,data)
     }

 ////Complaint Registration – Subscriber 002
     public postComplaintRegistration(data): Observable<any> {
        return this.http.post(APIConstants.COMPLAINTREG,data)
     }
   // GetAllDNDComplaints for complaint summary
     public getAllDNDComplaints(): Observable<any> {
       
        return this.http.get(APIConstants.GETALLDNDCOMPLAINTS)
        .pipe(map(r => this.parseRjioComplaints(r)));
    } 

    public GetDND_COMPLAINTS_TSP(): Observable<any> {
       
       /*  return this.http.get(APIConstants.GetDND_COMPLAINTS_TSP+"RJIO")
        .pipe(map(r => this.parseRjiooComplaints(r))); */
// return this.http.get(APIConstants.GetDND_COMPLAINTS_TSP+"JI")

        return this.http.get(APIConstants.GetDND_COMPLAINTS_TSP+"JI")
        .pipe(map(r => this.parseRjiooComplaints(r)));
    }
    

    public getComplaintsForVirtualID(): Observable<any> {
  
       let virtual_id = this.db.get(Constants.SESSSION_STORAGE, Constants.VIRTUAL_MOB_ID);
       console.log("virtual_id :",virtual_id);
       let serviceProvider = "RJIO";
        return this.http.get(APIConstants.GETSUBSCRIBERANDPREFERENCEDETAILS+virtual_id+'/'+serviceProvider);
     
    }

    private parseRjiooComplaints(res: any): any {
        const data = res.reduce((acc, val) => {
            console.log("Val ____",val);
			if(val.oapupdate != undefined || val.tapupdate != undefined){
				console.log("have tap and oap")
            acc.push({
                'Complaint_No': val.dcmp,
                'ComplaintDate': val.cts,
                'MobileNo': val.msisdn,
                'TSP_Name': val.tap,
                'TM_Type': val.cli,
                'IncidentDate': val.uccdt,
                'ComplaintDesc': val.desc,
                'Status': val.sts,
                'TM_No_Header' : val.cli,
               // 'ProviderDesc' : val.Record.ProviderDesc,
                'TypeOfUCC': val.uccty,
                'T_Unique_Ref_No': val.uref,
               // 'O_Action_Taken': val.oapupdate[0].act,
                'T_Complaint_Status': val.stsbytap,
                'Complaint_Status': val.sts,
                'O_Action_Date': val.actdt,
               // 'O_Action_End_Date':val.Record.O_Action_End_Date,
               // 'Feedback_Date': val.Record.Feedback_Date,
               // 'Feedback_Time': val.Record.Feedback_Time,
               // 'Virtual_MobileNo': val.Record.Virtual_MobileNo,
               //commented the line below as error was coming
                //'T_OAP_Operator': val.tapupdate.oap
            });
			}
			else{
				console.log("no tap and oap inside else : ", val)
				console.log("cts in else : ", val.cts)
				console.log("uccdt in else : ", val.uccdt)
				 acc.push({
                'Complaint_No': val.dcmp,
                'ComplaintDate': val.cts,
                'MobileNo': val.msisdn,
                'TSP_Name': val.tap,
                'TM_Type': val.cli,
                'IncidentDate': val.uccdt,
                'ComplaintDesc': val.desc,
                'Status': val.sts,
                'TM_No_Header' : val.cli,
               // 'ProviderDesc' : val.Record.ProviderDesc,
                'TypeOfUCC': val.uccty,
                'T_Unique_Ref_No': "",
                'O_Action_Taken': "",
                'T_Complaint_Status': val.stsbytap,
                'Complaint_Status': "Open",//val.sts,
                'O_Action_Date': val.actdt,
               // 'O_Action_End_Date':val.Record.O_Action_End_Date,
               // 'Feedback_Date': val.Record.Feedback_Date,
               // 'Feedback_Time': val.Record.Feedback_Time,
               // 'Virtual_MobileNo': val.Record.Virtual_MobileNo,
                'T_OAP_Operator': ""
				//val.tapupdate.oap
            });
			}
            return acc;
        }, []);
        console.log("data :", data);
        return data;
    }
    
    private parseRjioComplaints(res: any): any {
        const data = res.reduce((acc, val) => {
            acc.push({
               'Complaint_No': val.dcmp,
                'ComplaintDate': val.Record.cts,
                'MobileNo': val.Record.msisdn,
                'TSP_Name': val.Record.tap,
                'TM_Type': val.Record.cli,
                'IncidentDate': val.Record.uccdt,
                'ComplaintDesc': val.Record.desc,
                'Status': val.Record.sts,
                'TM_No_Header' : val.Record.cli,
                //'ProviderDesc' : val.Record.ProviderDesc,
                'TypeOfUCC': val.Record.uccty,
                'T_Unique_Ref_No': val.Record.uref,
               // 'O_Action_Taken': val.Record.O_Action_Taken,
                'T_Complaint_Status': val.Record.sts,
               // 'T_OAP_Operator': val.Record.T_OAP_Operator
            });
            return acc;
        }, []);
        console.log("data :", data);
        return data;
    }

    
   

     public  complaintsSubscriber(data: any): Observable<any> {
        return this.http.post(APIConstants.INVOKE, data);
    }

    public  complaintUpdateByTAP(data: any): Observable<any> {
	console.log("in ");
        return this.http.post(APIConstants.INVOKE, data);
    }

    public actionByOAP(data: any): Observable<any> {
        return this.http.post(APIConstants.INVOKE, data);
    }

    public actionByTSP(data: any): Observable<any> {
        return this.http.post(APIConstants.INVOKE, data);
    }
    
    public getHeaderData(): Observable<any> {
        let sp = this.db.get(Constants.SESSSION_STORAGE, Constants.SP);
        return this.http.get(APIConstants.GET_HEADERS_FOR_APPROVAL+sp)
            .pipe(map(r => this.parseHeaderData(r)))
    }
    public getHeaderDataForTSP(): Observable<any> {
        let sp = this.db.get(Constants.SESSSION_STORAGE, Constants.SP);
        let serviceprovider = this.db.get(Constants.SESSSION_STORAGE, Constants.SERVICE_PROVIDER);
         return this.http.get(APIConstants.GETALLHEADERFORTSP+sp)
            .pipe(map(r => this.parseHeaderDataTSP(r)))
    }
    
    private parseHeaderData(res: any): any {
        let modRes = res.reduce((acc, val) => {
            acc.push({
                'Header_Name': val.Record.Header_Name,
                'Header_Content': val.Record.Content_Desc,
                'TM': val.Record.RTM_No,
                'Category': val.Record.Category_Type
            });
            return acc;
        }, []);
        return modRes;
    }

    private parseHeaderDataTSP(res: any): any {
        let modRes = res.reduce((acc, val) => {
            acc.push({
                'Header_Name': val.Record.Header_Name,
                'Header_Content': val.Record.Content_Desc,
                'TM': val.Record.RTM_No,
                'Category': val.Record.Category_Type,
                'Status': val.Record.Status
            });
            return acc;
        }, []);
        return modRes;
    }

    public downloadComplaints1(data): Observable<any> {
        
        var fromDate = data.Start_Date;
        var fromDateEpoch = new Date(fromDate);
        var fromDateEpochTime = fromDateEpoch.getTime().toString();
 
        var toDate = data.End_Date;
        var toDateEpoch = new Date(toDate);
        var toDateEpochTime = toDateEpoch.getTime().toString();       
	
        console.log(" fromDate : ",fromDate, " toDate : ",toDate)
		return this.http.get(APIConstants.COMPLAINTSDOWNLOAD +'/'+fromDate +'/'+toDate,{responseType:'text'})
     //return this.http.get(APIConstants.COMPLAINTSDOWNLOAD +'/'+fromDateEpochTime +'/'+toDateEpochTime +'/'+SearchValue,{responseType:Â 'text'})
        
     }

 public downloadComplaints(data): Observable<any> {
       console.log(" fromDate : ",data.Start_Date,"type",data.type,"enddate :",data.End_Date)
	   return this.http.get(APIConstants.COMPLAINTSDOWNLOAD +'/'+data.Start_Date +'/'+data.End_Date +'/'+data.type+'/'+data.status,{responseType:'text'})
     }
    public approveORReject(headerName: string, status: string): Observable<any> {
        let todayDate = new Date();
        let data = {
            "header": {
                "event_const": "CNST_APPROVE_HEADER_EVENT",
                "head_id": 123
            },
            "jsonblob": {
                "Header_Name": headerName,
                "TSP_Approve_Date": todayDate,
                "Status": status
            }
        }
        return this.http.post(APIConstants.INVOKE, data);
    }

    public getComplaintsFilter(param,fdate,ldate): Observable<any> {
        return this.http.get(APIConstants.GETALLCOMPLAINTSFILTER+param+'/'+fdate+'/'+ldate)
		.pipe(map(r => this.parseComplaintsFilter(r)));          
    }
	    private parseComplaintsFilter(res: any): any {
        const data = res.reduce((acc, val) => {
            acc.push({
               'Complaint_No': val.dcmp,
                'ComplaintDate': val.cts,
                'MobileNo': val.msisdn,
                'TM_Type': val.cli,
                'IncidentDate': val.uccdt,
                'ComplaintDesc': val.desc,
                'Status': val.sts,
                'TM_No_Header' : val.cli,
                'TypeOfUCC': val.uccty,
                'T_Unique_Ref_No': val.uref,
                'Complaint_Status': val.sts,
            });
            return acc;
        }, []);
        console.log("data :", data);
        return data;
    }
    public getImportComplaintsSummary(): Observable<any> {
        return this.http.get(APIConstants.IMPORTCOMPLAINTSUMMARY);

    }

}